module.exports = __webpack_public_path__ + "img/blog-cv-3-x1.b88002ae.webp";